import { useState } from 'react';
import { apiFetchAdmin } from '../../../hooks/apiFetch';
import { SearchInput } from '../../../components/search/Search';
import { useAdminUsers } from "../../../context/Admins/AdminUsersContext"
import { useAdmin } from "../../../context/Admins/AdminContext"

import Pagination from "../../../utilities/Pagination";
import ItemsToShow from '../../../components/common/ItemsToShow';
import AdminUsers from './components/AdminUsers';

export function SettingUsers() {
    const { loading, currentPage, setCurrentPage,
        searchQuery, setSearchQuery, userDataTotalCount, setUserDataTotalCount,
        usersData, setUsersData, setItemsLimit, itemsLimit } = useAdminUsers()
    const { profile } = useAdmin()
    const [error, setError] = useState(null);
    const totalPages = usersData?.data?.paginationInfo.totalPagesCount;

    const handleUserDelete = async (id) => {
        try {
            await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users/${id}`, { method: "DELETE" });
            // Refresh the users list after deletion
            const data = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users?${searchQuery ? "" : "page=" + currentPage + "&"}limit=${searchQuery ? userDataTotalCount : 10}`);
            setUsersData(data);
            setUserDataTotalCount(data.data?.paginationInfo.totalCount);
        } catch (err) {
            setError("هناك مشكلة في الحذف");
        }
    };

    const filteredUsers = usersData?.data?.result.filter(user =>
        user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.mobilePhone.includes(searchQuery)
    );

    if (error) return <div className="text-center my-4 text-danger">{error}</div>;
    if (!usersData) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (
        <div className="container my-3 rounded bg-light-gray position-relative p-3">
            <div className="d-flex flex-wrap justify-content-center ">
                <SearchInput
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                />
                <ItemsToShow
                    setItemsLimit={setItemsLimit}
                    itemsLimit={itemsLimit}
                />
                <div className="container mt-3 position-relative p-3 overflow-auto text-nowrap">
                    {!loading ?
                        <table className="table table-hover">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col">كود</th>
                                    <th scope="col">الاسم</th>
                                    {/* <th scope="col">تاريخ الميلاد</th> */}
                                    <th scope="col">رقم الجوال</th>
                                    <th scope="col">البريد الالكتروني</th>
                                    <th scope="col" className={`${profile.data?.role !== "superAdmin" && "d-none"}`}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map((user) => (
                                    <AdminUsers
                                        key={user.id}
                                        id={user.id}
                                        birthDate={user.birthDate}
                                        fullName={user.firstName + " " + user.lastName}
                                        email={user.email}
                                        mobilePhone={user.mobilePhone}
                                        createdAt={user.createdAt}
                                        role={profile.data?.role}
                                        handleOnClick={() => handleUserDelete(user.id)}
                                    />
                                ))}
                            </tbody>
                        </table>
                        : <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>}
                </div>
                {totalPages > 1 &&
                    <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages} />
                }
            </div>
        </div>
    )
}